import { elementSettings } from '@yola/ws-sdk';
import settings from './settings';
import config from './constants/config';

const getExtension = () => ({
  slug: config.slug,
  title: 'WS Media',
  settings: {
    querySelector: '',
  },
  ui: {
    control: [],
  },
  init() {
    elementSettings.operations.registerElementSettings(settings.getThisMediaSettings());
  },
});

export default getExtension;
